"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.DaysInteractor = void 0;
const core_1 = require("@veeam/core");
require("../../../core");
const DaysModel_1 = require("./DaysModel");
class DaysInteractor extends core_1.Interactor {
    constructor(model, listener) {
        super();
        this.model = model;
        this.listener = listener;
        this.onSelectionDone = () => {
            const modelValue = this.form.getValue();
            const isValid = this.isValid(modelValue);
            if (!isValid) {
                return;
            }
            this.listener.onDeactivate();
            this.listener.onDone(DaysModel_1.DaysModel.getSelectedDaysFromModelValue(modelValue));
        };
        this.onViewDone = () => {
            const modelValue = this.form.getValue();
            this.listener.onDeactivate();
            this.listener.onDone(DaysModel_1.DaysModel.getSelectedDaysFromModelValue(modelValue));
        };
        this.onClose = () => {
            var _a, _b;
            this.listener.onDeactivate();
            (_b = (_a = this.listener).onClose) === null || _b === void 0 ? void 0 : _b.call(_a);
        };
        this.onCancel = () => {
            var _a, _b;
            this.listener.onDeactivate();
            (_b = (_a = this.listener).onCancel) === null || _b === void 0 ? void 0 : _b.call(_a);
        };
        this.isValid = (modelValue) => {
            return Object.values(modelValue).filter(Boolean).length > 0;
        };
        this.model = model;
        this.form = new core_1.Form(this.model);
        this.listener = listener;
    }
}
exports.DaysInteractor = DaysInteractor;
//# sourceMappingURL=DaysInteractor.js.map